@use 'shared/styles/generated/tokens' as *;
@use 'shared/styles/mixins' as *;

.root {
  flex: none;
  border-radius: $radius-round;
  overflow: hidden;
  background: $color-surface-alt;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 16%;
}

.hasGlow {
  box-shadow: $glow-shine;
}
